import { SC_API_ENDPOINT } from "consts";
import { isEmpty, omitBy } from "lodash";
import RestAPIClient from "services/RestAPIClient";
import { IPageableData } from "services/typings";
import { ICurrentSellerUser, IGetSellerRequest, ISeller } from "./typings";

class SCService extends RestAPIClient {
  constructor() {
    super(
      {
        endpoint: `${SC_API_ENDPOINT}/seller/v2`,
      },
      false
    );
  }

  private currentUser: ICurrentSellerUser | undefined;

  getCurrentUser = () => this.currentUser;

  setCurrentUser = (user: ICurrentSellerUser) => {
    this.currentUser = user;
  };

  getSellers = async (
    req: IGetSellerRequest
  ): Promise<IPageableData<ISeller>> => {
    const res = await this.get("sellers", omitBy(req, isEmpty));
    return {
      data: res.data,
      total: res.paging.total,
    };
  };
}

export default new SCService();
